__webpack_require__.p = "/partnerportal/";